import axios from "axios"
export function userExists(phoneNumber) {
    return axios.post(process.env.REACT_APP_API_URL+ '/userExists', { phoneNumber: phoneNumber });
       
}